// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_68abb93","open":"_fe6d396","icon":"_37db321"};